import type IMessageAvatarProps from "./type";
import type {
    MessagePartContentProps
} from "../../type";
import {
    MESSAGE_PLAIN_AVATAR_SIZE,
    MESSAGE_AVATAR_SIZES
} from "../../stylesheet";
import {
    withMessageContext
} from "../../context";
import Avatar from "../../../avatar";

const MessageAvatarContent = ({
    customTheme,
    context,
    ...props
}: MessagePartContentProps<IMessageAvatarProps>) => {
    return <Avatar
        size={context.isPlain ? MESSAGE_PLAIN_AVATAR_SIZE : MESSAGE_AVATAR_SIZES[context.size]}
        customTheme={customTheme ?? context.avatar?.customTheme ?? context.customTheme}
        customLocalize={context.customLocalize}
        title={context.title}
        {...context.avatar}
        {...props}
    />;
};

const MessageAvatar = withMessageContext<IMessageAvatarProps>("Avatar", MessageAvatarContent);
export default MessageAvatar;
